import { Util } from './_util.js';
import { gsap, ScrollTrigger } from 'gsap/all';

const App = {
  sayHelloTest: function (fName) {
    console.log(`Hello, ${fName}`);
  },
  gsap: function () {
    gsap.to('.site-title a', { color: 'red' });
  },
  init: function () {
    gsap.registerPlugin(ScrollTrigger);

  },
};

export default App;
